import { Card, Skeleton, CardContent, Box } from '@mui/material';

export default function SkeletonCard() {
  return (
    <Card
      sx={{
        width: 342,
        height: 236,
        backgroundColor: 'rgba(33, 28, 26, 0.4)',
        border: '1px solid #163632',
      }}
    >
      <CardContent>
        <Skeleton variant="rectangular" height={40} width="60%" />
        <Box display="flex" alignItems="center" mt={2} gap={2}>
          <Skeleton variant="circular" width={60} height={60} />
          <Box>
            <Skeleton width={120} height={20} />
            <Skeleton width={180} height={15} />
          </Box>
        </Box>
        <Skeleton height={36} width="50%" sx={{ mt: 3 }} />
      </CardContent>
    </Card>
  );
}
